// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>72</span>&nbsp;&nbsp;The law of your mouth is dearer to me&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;than a hoard of gold and silver.<br> </p> </div></div>";
// Exports
module.exports = code;